import React, { useState } from "react";
import { toast } from "react-toastify";
import { apiBaseUri } from "../config";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();

    if (!trimmedEmail || !trimmedPassword) {
      toast.error("Please enter both email and password.");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await fetch(`${apiBaseUri}/admin-login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        credentials: "include",
        body: new URLSearchParams({
          email: trimmedEmail,
          password: trimmedPassword,
        }),
      });

      if (!response.ok) {
        let message = "Login failed. Please try again.";
        try {
          const data = await response.json();
          message = data?.message || message;
        } catch (error) {
          // ignore json parse errors
        }
        toast.error(message);
        return;
      }

      const data = await response.json().catch(() => null);
      const redirectUrl =
        data?.redirectUrl || data?.data?.redirectUrl || "/" ;
      window.location.href = redirectUrl;
    } catch (error: any) {
      toast.error(error?.message || "Login failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="background-img w-screen h-screen centered-page">
      <div className="flex flex-col gap-y-3 p-8 rounded-xl bg-white">
        <h1 className="text-3xl font-bold mb-10">
          Digital girls hub Admin Portal
        </h1>
        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-y-3 w-full max-w-[600px]"
        >
          <input
            type="text"
            name="email"
            placeholder="Email"
            className="input-primary"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            className="input-primary"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          <input
            type="submit"
            className="btn-primary"
            value={isSubmitting ? "Logging in..." : "Login"}
            disabled={isSubmitting}
          />
        </form>
      </div>
    </div>
  );
}
